<template>
	<div class="footer">
		CopyRight © {{appdata.list.year}} 山西弛方电子商务有限公司  备案号:晋ICP备2025060963号 经营许可证编号:晋B2-20250128
	</div>
</template>

<script>
	export default {
		name: 'myfooter',
		data() {
			return {
				
			}
		},
		
		inject: ['appdata'],
	}
</script>

<style>
	.footer {
		width: 100%;
		height: 60px;
		background-color: #eaeaea;
		color: #777;
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 1200px;
	}
</style>


// WEBPACK FOOTER //
// src/common/myfooter.vue